// src/utils/urlService.js
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
// @ts-ignore
import { normalizeUrl } from "./Utils";
export const localStorageThemeUriKey = 'themeUri';
// Load app info on iOS asynchronously
let appInfo;
if (Capacitor.getPlatform() === 'ios')
    appInfo = await App.getInfo();
export function getAppUrl() {
    switch (Capacitor.getPlatform()) {
        case 'web':
            return new URL(window.location.href);
        case 'ios':
            // Is the app bound to a brand?
            const localStorageThemeUri = localStorage.getItem(localStorageThemeUriKey);
            if (localStorageThemeUri !== null)
                return new URL(normalizeUrl(localStorageThemeUri));
            // Reverse bundle identifier to url
            if (!appInfo)
                throw new Error('App info not available yet (loaded asynchronously)');
            const toDnsLabel = (s) => s
                .replace(/([a-z0-9])([A-Z])/g, '$1-$2') // camelCase -> kebab-case
                .replace(/[^a-zA-Z0-9-]/g, '-') // nur alphanumerisch + '-'
                .replace(/--+/g, '-') // doppelte '-' zusammenfassen
                .replace(/^-+|-+$/g, '') // Trennstriche am Rand entfernen
                .toLowerCase();
            const parts = appInfo.id.split('.').filter(Boolean);
            if (parts.length === 0)
                return new URL('https://nfc-config.app');
            const labels = parts.reverse().map(toDnsLabel).filter(Boolean);
            const host = labels.join('.');
            return new URL(`https://${host}`);
        default:
            throw new Error('Unsupported Capacitor platform ' + Capacitor.getPlatform());
    }
}
